<template>
  <Transition name="fade">
    <Loader v-if="!$beet.isReady" />
  </Transition>
  <template v-if="$beet.isReady">
    <SiteNav />
    <RouterView v-slot="{ Component }">
      <Transition name="fade-fast">
        <component :is="Component" />
      </Transition>
    </RouterView>
    <Footer />
    <Gdpr :options="{ backgroundColor: '#c74223', color: '#fff' }" />
    <Popup />
  </template>
</template>

<script>
import Gdpr from '@/components/gdpr/Gdpr.vue'
import Popup from '@/components/modal/Popup.vue'
import SiteNav from '@/components/navigation/SiteNav.vue'
import Footer from '@/components/sections/Footer.vue'
import Loader from '@/components/small/Loader.vue'
import { useLangRouter } from '@/extensions/langRouter'

export default {
  name: 'App',
  setup() {
    useLangRouter()
  },
  components: { Gdpr, Footer, Loader, Popup, SiteNav },
  watch: {
    '$i18n.locale': {
      handler: function (to) {
        this.$beet.fetchCoreData(to)
      },
      immediate: true,
    },
  },
  mounted() {
    setTimeout(() => {
      const el = this.$route.hash ? document.querySelector(this.$route.hash) : null
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }, 500)
  },
}
</script>
